export default __webpack_public_path__ + "static/media/spatter1.6e54ea7b.png";